<template>
  <div class="courseware">
    <Header></Header>
    <div class="detail-wrapper" style="padding-top:70px;">
      <div class="bg-white-wrapper">
        <div class="container location">
          <Breadcrumb class="breadcrumb" separator="»">
            <BreadcrumbItem to="/">首页</BreadcrumbItem>
            <BreadcrumbItem>学习中心</BreadcrumbItem>
            <BreadcrumbItem>{{ categoryInfo.title }}</BreadcrumbItem>
            <BreadcrumbItem>课程资料</BreadcrumbItem>
          </Breadcrumb>
        </div>
      </div>

      <div class="container ware-list">
        <div class="ware-item" v-for="(item, index) in dataList" :key="index">
          <div class="ware-title">
            <span class="ware-text">{{ item.title }}</span>
          </div>
          <a :href="item.dl_adr" class="ware-down">
            下载
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getCategoryInfo,
    getCourseWare,
  } from "../../api/api";
  import Header from '../../components/header.vue'
  export default {
    data() {
      return {
        cid: 0,
        categoryInfo: [],
        dataList: [],
      };
    },
    mounted() {
      let cid = this.$route.params.cid;
      if (!cid) {
        this.$Message.error("参数错误");
        return;
      }
      this.cid = cid;
      this.getCourseWare();
    },
    methods: {
      getCourseWare() {
        getCourseWare({cid:this.cid}).then((res) => {
          //console.log(res);
          if (res.code === 1) {
            this.categoryInfo = res.data.course;
            this.dataList = res.data.list;
          }
        });
      },
    },
    components: {
      Header
    },
  };
</script>

<style lang="less" scoped>
  .location {
    padding: 1rem 0;
  }

  .ware-list {
    padding-top: 20px;
  }

  .ware-item {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .ware-title {
      flex: 1;

      .ware-icon {
        margin-right: 10px;
      }

      .ware-text {}
    }

    .ware-down {
      flex: 0 0 48px;
      width: 48px;

      img {
        width: 48px;
        height: 48px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/exercise/CourseWare.vue